module.exports = __webpack_public_path__ + "static/img/avatar_r_4.ca4005ab.png";